import { createSelector } from 'reselect'

export const selectCreateActivityStoryLoading = (state) => state.feed.createActivityStoryLoading
export const selectActivityStories = (state) => state.feed.activityStories
export const selectFilteredActivityStories = createSelector(
  selectActivityStories,
  (stories) => {
    return stories.filter(story => story.object.subtype !== 'product_static')
  }
)



// WEBPACK FOOTER //
// ./src/services/feed/selectors.js